import PaginationController from './pagination.controller';
import template from './pagination.html';
import './pagination.less';

const PaginationComponent = {
  bindings: {
    // the number of results available for pagination - used to calculate number of pages
    numberOfResults: '<',
    // set in the parent, sets how many results should appear on each page
    resultsPerPage: '<',
    // linking function to update the current page in the parent
    updatePaginationCurrentPage: '&',
    // passes in the currentPage number from the parent
    currentPage: '<'
  },
  template,
  controller: PaginationController,
};

export default PaginationComponent;



// WEBPACK FOOTER //
// ./src/components/pagination/pagination.component.js